import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageFullwidth } from 'components/page/sections/page-section-two-columns-image-fullwidth';
import {
  SectionContentLinkList,
  SectionContentLinkListIdTwo,
} from 'components/section-content-link-list';

export const TabTwoContainer: React.FC = () => {
  const list = [
    {
      id: SectionContentLinkListIdTwo.UsingYourInformation,
      text: sections.tabTwoSection.section1.title(),
    },
    {
      id: SectionContentLinkListIdTwo.OurMatchingAlgorithms,
      text: sections.tabTwoSection.section2.title(),
    },
    {
      id: SectionContentLinkListIdTwo.ModerationPractices,
      text: sections.tabTwoSection.section3.title(),
    },
    {
      id: SectionContentLinkListIdTwo.LawfulBasis,
      text: sections.tabTwoSection.section4.title(),
    },
    {
      id: SectionContentLinkListIdTwo.BeePitched,
      text: sections.tabTwoSection.section5.title(),
    },
    {
      id: SectionContentLinkListIdTwo.ConnectionQuizzes,
      text: sections.tabTwoSection.section6.title2(),
    },
  ];
  const props = {
    columnLeft: {
      title: sections.tabTwoSection.tab.title(),
      subTitle: sections.tabTwoSection.tab.text(),
    },
    columnRight: {
      title: sections.tabTwoSection.tab.contents.title(),
      content: <SectionContentLinkList list={list} />,
    },
    image: {
      src: `${CdnImagePath}/assets/tab-02/tab-02-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
  };

  return <PageSectionTwoColumnsImageFullwidth {...props} />;
};
